<template>
  <div id="lineinfobox">
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 0C7.83594 0 0 7.83594 0 17.5C0 27.1641 7.83594 35 17.5 35C27.1641 35 35 27.1641 35 17.5C35 7.83594 27.1641 0 17.5 0ZM19.9609 27.5742C19.9609 28.8984 18.8789 29.9805 17.5547 29.9805H17.3672C16.043 29.9805 14.9609 28.8984 14.9609 27.5742V27.3867C14.9609 26.0625 16.043 24.9805 17.3672 24.9805H17.5547C18.8789 24.9805 19.9609 26.0625 19.9609 27.3867V27.5742ZM19.9609 20.0391C19.9609 21.3867 18.8555 22.4922 17.5078 22.4922H17.4102C16.0625 22.4922 14.957 21.3867 14.957 20.0391V7.4375C14.957 6.08984 16.0625 4.98438 17.4102 4.98438H17.5078C18.8555 4.98438 19.9609 6.08984 19.9609 7.4375V20.0391Z" fill="var(--color-pri)"/>
    </svg>
    <div>
      <div>
        <div>本月的預設上限: {{info.limitMax||500}}</div>
      </div>
      <div>
        <div>已傳送訊息則數: {{info.countUsed||0}}</div>
        <div>超額訊息則數: 0</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['info']

}
</script>

<style lang="scss">

</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
#lineinfobox {
  margin: 10px 20px;
  width: calc(100% - 40px);
  min-height: 73px;
  background-color: var(--color-infobox);
  flex: 1;
  display: flex;
  align-items: center;
  padding: 6px 20px;
  gap: 15px;
  &>div{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    &>div{
      text-align: start;
      display: grid;
      grid-template-columns: repeat(2, 363px);
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      letter-spacing: 0.1em;
      color: var(--color-pri);
    }
  }
}
</style>
